import { Button, Drawer, Space, type DrawerProps } from "antd"
import { useHybridResponsive } from "..";

interface DrawerDetailsProps {
   title: string,
   //placement?: DrawerProps['placement'],
   open: boolean,
   onClose?: () => void,
   size?: string,
   contentBody: React.ReactNode
}

const DrawerDetails = ({ title, open, onClose, contentBody, size = '80%' }: DrawerDetailsProps) => {
   const { isMobile } = useHybridResponsive();
   let placement: DrawerProps['placement'] = 'right';
   if (isMobile) {
      placement = 'bottom';
   }
   return (
      <Drawer
         title={title}
         placement={placement}
         size={size}
         onClose={onClose}
         open={open}
         extra={
            <Space>
               <Button onClick={onClose}>Cerrar</Button>
            </Space>
         }
      >
         {contentBody}
      </Drawer>
   )
}

export default DrawerDetails;